import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, CardMedia } from '@mui/material';
import SEO from '../components/SEO';

const Faculty = () => {
  const facultyMembers = [
    {
        name: "Kishan Chitara",
        position: "Physics",
        experience: "7 Years Experience",
        image: "/faculty.png"
    },
    {
      name: "Abhishek Bhandari Sir",
      position: "Mathematics",
      experience: "15 years",
      image: "/faculty.png"
    },
    {
      name: "Abhimanyu Bhatt Sir",
      position: "Physics",
      experience: "18 years",
      image: "/faculty.png"
    },
    {
      name: "Dr. Pratham Sir",
      position: "Chemistry",
      experience: "5 years (PW Online Faculty)",
      image: "/faculty.png"
    },
    {
      name: "Motilal Ji Sir",
      position: "Biology",
      experience: "8 years (1st Grade Government Teacher)",
      image: "/faculty.png"
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO 
        title="Our Expert Faculty - SOLID CLASSES"
        description="Meet our experienced faculty at SOLID CLASSES. Expert teachers in Physics, Chemistry, Mathematics, and Biology with years of teaching experience and proven track record."
        keywords="SOLID CLASSES faculty, best teachers in Jodhpur, physics teacher, chemistry teacher, mathematics teacher, biology teacher, NEET JEE faculty"
      />
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Our Faculty
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph align="center" sx={{ mb: 6 }}>
        Meet our experienced and dedicated teaching staff
      </Typography>
      
      <Grid container spacing={4}>
        {facultyMembers.map((member, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardMedia
                component="img"
                height="200"
                image={member.image}
                alt={member.name}
                sx={{ objectFit: 'contain', backgroundColor: 'transparent' }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  {member.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {member.position}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Experience: {member.experience}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Faculty; 
